exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-bordered thead th[data-v-636755ea] {\n  font-weight: 600;\n}", ""]);

// exports
